import { useState } from 'react';
import ActivityDetector from 'react-activity-detector';
import CountdownModal from 'library/components/modal/countdown';

const EVENTS = ['click', 'mousemove', 'keydown', 'DOMMouseScroll', 'mousewheel', 'mousedown', 'touchstart', 'touchmove', 'focus', 'visibilitychange'];

const ActivityWatcher = ({ enabled, onInactive, timeout }) => {
  const [isInactive, setIsInactive] = useState();

  const onIdle = () => {
    setIsInactive(true);
  };

  const onActive = () => {
    setIsInactive(false);
  };

  if (!timeout) {
    return null;
  }

  return (
    <>
      <ActivityDetector
        activityEvents={EVENTS}
        enabled={enabled && timeout}
        timeout={timeout}
        onIdle={onIdle}
        onActive={onActive}
      />
      <CountdownModal
        isOpened={isInactive && enabled}
        onCountdownDone={onInactive}
      />
    </>
  );
};

export default ActivityWatcher;
